function TableNavigationItemPrevious({ page, goToPage, className = "" }) {

  return (
    <li className={className}>
      <a
        className={`arrow ${page === 1 ? 'disabled' : ''}`}
        onClick={(e) => { e.preventDefault(); goToPage(page - 1) }}
        href="#">
          &nbsp;
      </a>
    </li>
  )
}

export default TableNavigationItemPrevious